/*
 * @Author: Teemo Ding
 * @Date: 2021-08-26 14:48:21
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-26 15:08:23
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Payment/Components/FormNumberInput/index.tsx
 */
import React from 'react';
import { withRouter } from 'react-router-dom';

import { NumberInput } from 'src/components/Antd';
import { Wrapper } from 'src/components/EditableTable/TableForm1';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Test = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { _onBlur, error, value, onChange, ...rest } = props;
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div style={{ width: 100 }}>
        <NumberInput
          autoFocus
          value={value}
          onChange={onChange}
          error={error}
          onBlur={_onBlur}
          suffix={'%'}
          {...rest}
        />
      </div>

      <div> {getI18n('storePayment.formNumberInput.ofinvoicetotal')}</div>
    </div>
  );
};
const _Test = Wrapper(Test);

const FormNumberInput = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { value, onChange } = props;
  return (
    <div style={{ width: '100%', backgroundColor: '#fff' }}>
      <div style={{ width: 200 }}>
        <_Test
          value={value}
          onChange={onChange}
          label={`${value} % ${getI18n(
            'storePayment.formNumberInput.ofinvoicetotal',
          )}`}
        />
      </div>
    </div>
    //
  );
};
export default withRouter(FormNumberInput);
